// Valores por defecto de indicationsOfDangerSga.
export const defaultIndicationsOfDangerSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionIndicationOfDanger = () => {
    return "";
};

// Valor por defecto de indicationOfDanger.
export const defaultIndicationOfDanger = () => {
    return {
        id: null,
        name: null,
        code: null,
        sga_danger_indication_code_languages: [],
        parent_danger_indication_code_ids: [],
        parent_danger_indication_codes: [],
        prudence_tip_code_ids: [],
        sga_prudence_tip_codes: [],
    };
};

// Valores por defecto de filterIndicationsOfDangerSga.
export const defaultFilterIndicationsOfDangerSga = () => {
    return {
        name: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de activeIndicationsOfDangerSga.
export const defaultActiveIndicationsOfDangerSga = () => {
    return [];
};

export default {
    indicationsOfDangerSga: defaultIndicationsOfDangerSga(),
    action: defaultActionIndicationOfDanger(),
    indicationOfDanger: defaultIndicationOfDanger(),
    filterIndicationsOfDangerSga: defaultFilterIndicationsOfDangerSga(),
    activeIndicationsOfDangerSga: defaultActiveIndicationsOfDangerSga(),
};
